const doc = [({"da":({"js":({"admin":({"logs":({"headers":({"update":({"update":"Opdateret"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;